var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("span", [_vm._v(_vm._s(_vm.getTitle))]),
              _c("v-select", {
                attrs: {
                  outlined: "",
                  "item-text": "title",
                  "item-value": "value",
                  disabled: _vm.loadingData,
                  loading: _vm.loading,
                  items: _vm.$options.kioskBannerType,
                  value: _vm.bannerType,
                  "error-messages": _vm.errorBannerType,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("banner-type-change", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.getTypeBanner
        ? _c(
            "v-row",
            [
              _vm.getTypeBanner === "image"
                ? _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("MediaFilePicker", {
                        attrs: {
                          label: "Изображение",
                          multiple: false,
                          "file-type": _vm.$options.mediaTypesByKeys.IMAGE,
                          value: _vm.returnImageBannerId,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeBanner($event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.getTypeBanner === "video"
                ? _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("MediaFilePicker", {
                        attrs: {
                          label: "Видео",
                          multiple: false,
                          "file-type": _vm.$options.mediaTypesByKeys.VIDEO,
                          value: _vm.returnVideoBannerId,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeBanner($event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.getTypeBanner === "url"
                ? _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("span", [_vm._v("url")]),
                      _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          placeholder: "https://",
                          disabled: _vm.loadingData,
                          loading: _vm.loading,
                          value: _vm.returnUrlBanner,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.changeBanner($event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }